<template>
  <v-container fluid>
    <v-card class="mb-2">
      <v-card-title primary-title>
        <h3 class="headline mb-0">{{ $t('B1300.title') }}</h3>
        <v-spacer />
        <!-- <a
          @click="$watchVideo('B1300-01')"
          href="#"
          style="margin-left: 10px"
        >{{$t('app.buttons.videoTutorial')}}</a> -->
      </v-card-title>
      <v-card-actions>
        <v-btn
          @click="searchData"
          class="btn-search"
          v-permit.SHARP_SIP_SEARCH.SHARP_SIB_SEARCH
          >{{ $t('app.buttons.search') }}</v-btn
        >
        <v-btn @click="downloadParentDo">検索結果出力</v-btn>
        <!-- <v-btn @click="excelOpen" v-permit.SHARP_SIP_FROM_DOWNLOAD.SHARP_SIB_FROM_DOWNLOAD>帳票出力</v-btn> -->
        <v-btn
          :disabled="
            this.selected.length !== 1 || this.selected[0].hasShipment === false
          "
          @click="download"
          v-permit.SHARP_SIP_DOCUMENT_DOWNLOAD.SHARP_SIB_DOCUMENT_DOWNLOAD
          >{{ $t('app.buttons.docDownload') }}</v-btn
        >
        <v-btn
          @click="eiajsDownload('', 'business')"
          v-permit.SHARP_SIP_MODEL_DIM_FEE_DOWNLOAD
          >{{ $t('B1300.buttons.eiaj') }}速報</v-btn
        >

        <v-btn
          @click="eiajsDownload('', 'archive')"
          v-permit.SHARP_SIP_MODEL_DIM_FEE_DOWNLOAD
          >{{ $t('B1300.buttons.eiaj') }}実績（月次）</v-btn
        >
        <v-btn
          @click="packagesDownload"
          v-permit.SHARP_SIP_MODEL_DIM_FEE_DOWNLOAD
        >
          <!-- {{$t('B1300.buttons.eiaj')}} -->
          コンテナ明細
        </v-btn>
        <v-btn @click="downloadEta" v-permit.SHARP_SIP_ONE_WEEK_ETA_DOWNLOAD>{{
          $t('B1300.buttons.eta')
        }}</v-btn>
        <v-btn
          :disabled="this.selected.length !== 1"
          @click="sytcExcel"
          v-permit.SHARP_SIP_ARRIVAL_PLAN_DOWNLOAD
          >{{ $t('B1300.buttons.sytc') }}</v-btn
        >
        <v-btn
          @click="ctnWHSDownload"
          v-permit.SHARP_SIP_WAREHOUSE_CONTAINERS_QTY_DOWNLOAD
          >{{ $t('B1300.buttons.warehouseCtn') }}</v-btn
        >
        <v-btn
          @click="exportExcelByMonth"
          v-permit.SHARP_SIP_DELIVERY_SCHEDULE_MONTH_DOWNLOAD
          >{{ $t('B1300.buttons.byMonth') }}</v-btn
        >
        <v-btn @click="$clearQuery()">検索条件クリア</v-btn>
      </v-card-actions>
      <v-card-actions>
        <v-radio-group
          class="radio_group"
          hide-details
          row
          style="margin-top: 0px"
          v-model="doUnit"
        >
          <v-radio :label="$t('B1300.buttons.mother')" value="mother"></v-radio>
          <v-radio
            :label="$t('B1300.buttons.child')"
            @click="$router.push('/B1301')"
            value="child"
          ></v-radio>
        </v-radio-group>
      </v-card-actions>
    </v-card>

    <v-card>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2 sm6 xs6>
                  <date-picker
                    label="ETA"
                    v-model="query.etaFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2 sm6 xs6>
                  <date-picker
                    :min="query.etaFrom"
                    label="~"
                    v-model="query.etaTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="B/L No"
                v-model="query.blNo"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.productCode')"
                clearable
                v-model="query.productName"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.ctnNo')"
                clearable
                v-model="query.containerNo"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.ivNo')"
                clearable
                v-model="query.invNo"
              ></v-text-field>
            </v-flex>
            <v-flex
              md3
              sm6
              v-if="
                $store.getters.user.roles.every(
                  (r) => r.roleCode !== 'ROLE_PARTNER'
                )
              "
              xs12
            >
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.dischargePort')"
                url="ports/kv"
                v-model="query.dischargePortCode"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2 sm6 xs6>
                  <date-picker
                    :label="$t('app.labels.etd')"
                    v-model="query.etdFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2 sm6 xs6>
                  <date-picker
                    :min="query.etdFrom"
                    label="~"
                    v-model="query.etdTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <!-- </v-layout>
            <v-layout row wrap>-->
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2 sm6 xs6>
                  <date-picker
                    :label="$t('B1300.labels.warehousingDate')"
                    v-model="query.warehousingDateFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2 sm6 xs6>
                  <date-picker
                    :min="query.warehousingDateFrom"
                    label="~"
                    v-model="query.warehousingDateTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.warehouse')"
                url="warehouses/kv"
                v-model="query.finallyWarehouseId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                url="divisions/kv?type=BU"
                v-model="query.buHeadquartersId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.department.name')"
                url="divisions/kv?type=DEPARTMENT"
                v-model="query.departmentId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.shipName')"
                clearable
                v-model="query.shipName"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="入力者"
                v-model="query.saSendMailOperator"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="担当者"
                v-model="query.operatorId"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="D/O NO"
                v-model="query.doNo"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>

    <v-card class="mt-2">
      <fixed-column-wrap :data="results">
        <template slot-scope="{}">
          <v-data-table
            :headers="headers"
            :items="results"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="[10]"
            :total-items="pagination.totalItems"
            item-key="combineKey"
            select-all
            v-model="selected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>{{ props.item.doNo }}</td>
              <td>{{ props.item.branchCode }}</td>
              <td>{{ props.item.saSendMailOperator }}</td>
              <td>{{ props.item.blNo }}</td>
              <td>{{ props.item.skuCodes }}</td>
              <td>{{ props.item.qty }}</td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.productNames }}</td>
              <td>{{ props.item.partnerName }}</td>
              <td>{{ props.item.invoiceNo }}</td>
              <td
                style="color: red"
                v-if="props.item.shipmentType === 'BOOKINGSA'"
              >
                {{ props.item.containerNos }}
              </td>
              <td v-if="props.item.shipmentType !== 'BOOKINGSA'">
                {{ props.item.containerNos }}
              </td>
              <td>{{ props.item.containerType }}</td>
              <td>{{ props.item.loadingPortName }}</td>
              <td>{{ props.item.etd }}</td>
              <td>{{ props.item.dischargePortName }}</td>
              <td>{{ props.item.eta }}</td>
              <td>{{ props.item.warehousingDate }}</td>
              <td>{{ props.item.warehousingTime }}</td>
              <td>{{ props.item.forecastDeliveryDate }}</td>
              <td>{{ props.item.forecastDeliveryTime }}</td>
              <td>{{ props.item.finallyWarehouseName }}</td>
              <td>{{ props.item.drakeCompanyName }}</td>
              <td>{{ props.item.importDirectorNames }}</td>
            </template>
          </v-data-table>
        </template>
      </fixed-column-wrap>
    </v-card>
    <!-- <branch :doUnit="doUnit"></branch> -->
    <!-- <download-dialog :show="showDialog" v-on:closeEvent="closeEvent"></download-dialog> -->
    <download-doc-dialog
      :blNo="selected.length > 0 ? selected[0].blNo : ''"
      ref="DownloadDocDialog"
    ></download-doc-dialog>
    <excel-dialog :shipments="selected" ref="excelDialog"></excel-dialog>
    <eiaj-dialog ref="eiajsDialog"></eiaj-dialog>
    <container-dialog ref="containerDialog"></container-dialog>
    <ctn-whs-dialog ref="ctnWhsDialog"></ctn-whs-dialog>
    <total-excel-dialog ref="totalExcelDlg" />
  </v-container>
</template>

<script>
// import Branch from '../B1301/index'
import DownloadDocDialog from '@/components/DownloadDocDialog'
import ExcelDialog from './excelDialog'
import EiajDialog from './eiajDialog'
import ContainerDialog from './containerDialog'
import CtnWhsDialog from './ctnWHSDialog'
import TotalExcelDialog from './TotalExcelDialog'
export default {
  components: {
    DownloadDocDialog,
    ExcelDialog,
    EiajDialog,
    CtnWhsDialog,
    TotalExcelDialog,
    ContainerDialog,
  },
  data() {
    return {
      search: false,
      showDialog: false,
      selected: [],
      results: [],
      loading: false,
      pagination: {
        page: 1,
      },
      doUnit: 'mother',
      query: {},
      headers: [
        {
          text: 'D/O NO',
          value: 'doNo',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('B1300.labels.branchCode'),
          value: 'branchCode',
          sortable: false,
          class: 'fixed',
        },
        {
          text: '入力者',
          value: 'saSendMailOperator',
          sortable: false,
          class: 'fixed',
        },

        {
          text: 'B/L NO',
          value: 'blNo',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('app.labels.skuCode'),
          value: 'skuCode',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('app.labels.qty'),
          value: 'qty',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('B1300.labels.status'),
          value: 'status',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('app.labels.productCode'),
          value: 'productName',
          sortable: false,
        },
        {
          text: this.$t('app.labels.partner'),
          value: 'partnerName',
          sortable: false,
        },
        {
          text: 'I/V NO',
          value: 'invNo',
          sortable: false,
        },
        {
          text: this.$t('app.labels.ctnNo'),
          value: 'containerNo',
          sortable: false,
        },
        {
          text: this.$t('B1300.labels.ctnSize'),
          value: 'containerTypeName',
          sortable: false,
        },
        {
          text: this.$t('app.labels.loadingPort'),
          value: 'loadingPortCode',
          sortable: false,
        },
        {
          text: 'ETD',
          value: 'etd',
          sortable: false,
        },
        {
          text: this.$t('app.labels.dischargePort'),
          value: 'dischargePortCode',
          sortable: false,
        },
        {
          text: 'ETA',
          value: 'eta',
          sortable: false,
        },
        {
          text: this.$t('B1300.labels.warehousingDate'),
          value: 'warehousingDate',
          sortable: false,
        },
        {
          text: this.$t('B1300.labels.warehousingTime'),
          value: 'warehousingTime',
          sortable: false,
        },
        {
          text: this.$t('app.labels.forecastDeliveryDate'),
          value: 'forecastDeliveryDate',
          sortable: false,
        },
        {
          text: this.$t('B1300.labels.forecastDeliveryTime'),
          value: 'forecastDeliveryTime',
          sortable: false,
        },
        {
          text: this.$t('B1300.labels.finallyWarehouseName'),
          value: 'finallyWarehouseName',
          sortable: false,
        },
        {
          text: this.$t('B1300.labels.drakeCompanyName'),
          value: 'drakeCompanyName',
          sortable: false,
        },
        {
          text: '担当者',
          value: 'importDirectorNames',
          sortable: false,
        },
      ],
      dos: [],
      branches: [],
      ivCsvHeaders: [
        'doNo',
        'branchCode',
        'saSendMailOperator',

        'blNo',
        'skuCodes',
        'qty',
        'productNames',
        'status',
        'partnerName',
        'invoiceNo',
        'containerNos',
        'containerType',
        'loadingPortName',
        'etd',
        'dischargePortName',
        'eta',
        'warehousingDate',
        'warehousingTime',
        'forecastDeliveryDate',
        'forecastDeliveryTime',
        'finallyWarehouseName',
        'drakeCompanyName',
        'importDirectorNames',
      ],
    }
  },
  methods: {
    downloadParentDo() {
      this.$http
        .get('/commercial-invoices?needParam=true', {
          params: {
            ...this.query,
            ...this.$pageable(),
            size: 99999,
            page: 0,
          },
        })
        .then((res) => {
          console.log(res.data.content)
          this.$exportTable(
            res.data.content,
            this.ivCsvHeaders,
            this.headers.map((h) => h.text),
            'StatusCSV出力'
          )
        })
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      }
    },
    excelOpen() {
      this.$refs.excelDialog.popup()
    },
    load() {
      this.$storeParams()
      this.search = true
      this.loading = true
      this.$http
        .get('/commercial-invoices?view=B1300', {
          params: {
            ...this.query,
            ...this.$pageable(),
          },
        })
        // this.$http
        //   .get('/packings/display-status', {
        //     params: { ...this.query, ...this.$pageable() }
        //   })
        .then((res) => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.loading = false
          this.selected = []
        })
    },
    searchData() {
      this.pagination.page = 0
      this.load()
    },
    closeEvent(value) {
      this.showDialog = value
    },
    containerNos(item) {
      return item.packages
        .map((p) => p.containerNo)
        .reduce((a, b) => {
          if (a.indexOf(b) == -1) {
            a.push(b)
          }
          return a
        }, [])
        .join(',')
    },
    containerTypes(item) {
      return item.packages
        .map((p) => p.containerTypeName)
        .reduce((a, b) => {
          if (a.indexOf(b) == -1) {
            a.push(b)
          }
          return a
        }, [])
        .join(',')
    },
    skuCodes(skuCodes) {
      return skuCodes && skuCodes.split(',', 3).join(',')
    },
    productName(item) {
      return item.packages
        .map((p) => p.productName)
        .reduce((a, b) => {
          if (a.indexOf(b) == -1) {
            a.push(b)
          }
          return a
        }, [])
        .join(',')
    },
    invNo(item) {
      return item.packages
        .map((p) => p.invoiceNo)
        .reduce((a, b) => {
          if (a.indexOf(b) == -1) {
            a.push(b)
          }
          return a
        }, [])
        .join(',')
    },
    download() {
      this.$refs.DownloadDocDialog.popup()
    },
    exportExcelByMonth() {
      this.$refs.totalExcelDlg.popup().then((p) => {
        this.$download(
          `/reports/1?from=${p.from}&to=${p.to}&warehouseGroup=${
            p.warehouseGroup
          }`
        )
      })
    },
    sytcExcel() {
      this.$download(`/sytc/${this.selected[0].id}`)
        .then()
        .catch((res) => {
          if (res.response.status === 500) {
            console.log(res.response)
            if (res.response.data.size === 24) {
              this.$message(
                this.$t('app.messages.errors.title'),
                'inv情報のみの場合、出力できません。'
              )
            } else {
              this.$message('', `system error, module:${this.$route.path}`)
            }
          }
        })
    },
    ctnWHSDownload() {
      this.$refs.ctnWhsDialog.popup().then((p) => {
        this.$download(`/reports/ctnWhs?from=${p.from}&to=${p.to}`)
      })
    },
    eiajsDownload(root, path) {
      this.$refs.eiajsDialog.popup(this.$t('B1300.buttons.eiaj')).then((p) => {
        this.$download(`${root}/reports/eiajs/${path}`, {
          forecastDeliveryDateFrom: p.from,
          forecastDeliveryDateTo: p.to,
          buIds: p.buIds && p.buIds.join(','),
        })
      })
    },
    // this.$postDownload('/reports/packages')

    packagesDownload() {
      this.$refs.containerDialog.popup('コンテナ明細 案').then((p) => {
        this.$download('/reports/packages', {
          forecastDeliveryDateFrom: p.from,
          forecastDeliveryDateTo: p.to,
          buIds: p.buId && p.buId.join(','),
          warehouseIds: p.warehouseId && p.warehouseId.join(','),
          containerTypeIds: p.containerTypeId && p.containerTypeId.join(','),
        }).catch((err) => {
          console.log(err)
          if ('TimeOut' === err) {
            this.$message(
              'Err',
              '検索結果が多いので、出力できません。検索条件を調整する上で、再度検索してください。'
            )
          }
        })
      })
    },
    downloadEta() {
      this.$download(`/reports/2?leDay=7`)
    },
  },
  mounted() {
    this.$loadParams()
  },
  watch: {
    pagination() {
      if (this.search) this.load()
    },
  },
}
</script>

<style scoped>
.v-btn {
  margin: 5px !important;
}
</style>
